<template>
    <div v-html="aa"></div>
    <!-- <div></div> -->
</template>

<script>
export default {
   data(){
       return{
          aa:'<p class="media-wrap image-wrap"></p><p class="media-wrap image-wrap"></p><p class="media-wrap image-wrap"></p><p class="media-wrap image-wrap"></p><p class="media-wrap image-wrap"></p><div class="media-wrap image-wrap"  style="box-sizing:border-box;display:flex"  ><img poster="" src="http://shuju-jtzx.oss-cn-shanghai.aliyuncs.com/images/2021/1/22/a9821b1d-9d84-4a9b-b485-e9b8df688a90.jpg"/></div><div class="media-wrap image-wrap"  style="box-sizing:border-box;display:flex"  ><img poster="" src="http://shuju-jtzx.oss-cn-shanghai.aliyuncs.com/images/2021/1/22/d5f63d86-d6a4-4f7c-8a89-25b7af3c29e6.jpg"/></div><div class="media-wrap image-wrap"  style="box-sizing:border-box;display:flex"  ><img poster="" src="http://shuju-jtzx.oss-cn-shanghai.aliyuncs.com/images/2021/1/22/13903946-5a59-44d2-80ca-d261d9d4e9ed.jpg"/></div><div class="media-wrap image-wrap"  style="box-sizing:border-box;display:flex"  ><img poster="" src="http://shuju-jtzx.oss-cn-shanghai.aliyuncs.com/images/2021/1/22/ed94107e-b4a5-4fc2-842e-1edeec7cbb6f.jpg"/></div><div class="media-wrap image-wrap"  style="box-sizing:border-box;display:flex"  ><img poster="" src="http://shuju-jtzx.oss-cn-shanghai.aliyuncs.com/images/2021/1/22/e1659046-badb-4ec5-bbef-68ded5f14c2f.jpg"/></div>'
       }
   },
   mounted(){
    //    var reg = new RegExp( '<p></p>' , "g" )

    //  let str=  this.aa.replace(reg,'')
   
    //    var reg2 = new RegExp( '<div class="media-wrap image-wrap">' , "g" )
    //   let str2=  str.replace(reg2,'<div class="media-wrap image-wrap"  style="font-size:0px"  >')
    //   this.aa=str2
   },
}
</script>

 <style lang="less">
div{
    /deep/ img{
        width: 98%
    }
}
</style>

